import { translate } from '../../../common/utility/DisplayPrep';
const { READ_ONLY_FEATURES } = process.env;

const actions = READ_ONLY_FEATURES === 'true' ? ['edit'] : ['edit', 'delete'];

export const defaultUiConfig = {
    name: 'Security Permissions',
    withActions: actions,
    primaryKey: 'uuid',
    pageSize: 10,
    properties: {
        schemeId: {
            name: 'Scheme Id',
            rowDisplay: false,
            sortable: true
        },
        permissionClass: {
            name: 'Permission Class',
            nullable: false,
            rowDisplay: true,
            sortable: true,
            input: 'select',
            optionsSort: 'alphabetical'
            // accessorOverride: (v) => {
            //     return v?.permissionClass;
            // }
        },
        permissionType: {
            name: 'Permission Type',
            nullable: false,
            rowDisplay: true,
            sortable: true,
            input: 'select',
            optionsSort: 'alphabetical'
        },
        cascade: {
            name: 'Cascade?',
            rowDisplay: true,
            sortable: true,
            input: 'checkbox',
            inputProps: {
                checkboxlabel: 'Is cascading?'
            }
            // onChange: (v) => {

            // }
            // accessorOverride: (v) => {
            //     return v?.deny ? true : false;
            // }
        },
        deny: {
            name: 'Deny?',
            rowDisplay: true,
            sortable: true,
            input: 'checkbox',
            inputProps: {
                checkboxlabel: 'Deny?'
            }
            // accessorOverride: (v) => {
            //     return v?.deny ? 'Yes' : 'No';
            // }
        },
        mapId: {
            name: 'Map ID',
            rowDisplay: false,
            sortable: true
        },
        lastModId: {
            rowDisplay: false,
            name: 'Last Modified ID'
        },
        lastModDatetime: {
            rowDisplay: false,
            displayPrep: 'FullDate',
            name: 'Last Modified Datetime',
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        createId: {
            rowDisplay: false,
            name: 'Create ID'
        },
        createDatetime: {
            rowDisplay: false,
            name: 'Create Datetime'
        }
    },
    newDoc: {
        cascade: false,
        deny: false,
        mapId: null,
        permissionClass: null,
        permissionType: null,
        schemeId: null,
        createDatetime: null,
        createId: null,
        dtoState: 'NEW',
        lastModDatetime: null,
        lastModId: null
    }
};

export default defaultUiConfig;
